export default __webpack_public_path__ + "static/media/dl.b7c77185.svg";